// src/components/SaleCancelForm/SaleCancelReasonSection.tsx
import React from 'react';
import TextAreaField from '../../../components/Forms/Input/TextAreaField';
import { useSaleInvalidation } from '../../../hooks/sale/useSaleInvalidation';

type Props = {
  onSubmit: () => void; // la acción que ya tengas para enviar
};

const SaleCancelReasonSection: React.FC<Props> = ({ onSubmit }) => {
  const { form, formErrors, updateField, isSubmitting } = useSaleInvalidation();

  return (
    <div className="space-y-6">
      {/* Campo de texto (ligado al form.comment) */}
      <TextAreaField
        label="Motivo de Anulación"
        name="comment"
        placeholder="Ejemplo: El cliente solicitó la cancelación total de la operación por error en el producto entregado."
        value={form.comment ?? ''}
        onChange={(e) => updateField('comment', e.target.value)}
        iconKey="edit"
        rows={4}
        required
        error={formErrors.comment}
      />

      {/* Botón de acción */}
      <div className="flex justify-end">
        <button
          type="button"
          onClick={onSubmit}
          disabled={isSubmitting}
          className="inline-flex rounded bg-[#DC3545] px-4 py-2 font-semibold text-white hover:bg-opacity-90 disabled:opacity-50"
        >
          {isSubmitting ? 'Anulando...' : 'Anular Venta'}
        </button>
      </div>
    </div>
  );
};

export default SaleCancelReasonSection;
